export default "__VITE_ASSET__BTnfi3IZ__"